module.exports = __webpack_public_path__ + "static/media/bestamma.525317bf.mp3";